import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=bcd127f0&scoped=true"
import script from "./LanguageSwitch.js?vue&type=script&lang=js&external"
export * from "./LanguageSwitch.js?vue&type=script&lang=js&external"
import style0 from "./LanguageSwitch.scss?vue&type=style&index=0&id=bcd127f0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd127f0",
  null
  
)

export default component.exports